import React from "react";
import PrimaryButton from "../../components/PrimaryButton";
import SelectDropdown from "../../components/SelectDropdown";
import { Card, Col, Form, Row } from "react-bootstrap";
import GenerateModal from "../../components/GenerateModal";
import useCreateNewViewController from "../../viewControllers/HomeViewControllers/CreateNewViewController";
import i18n from "../../constants/Strings";

const CreateNew = () => {
  const {
    goBack,
    state,
    handleSubmit,
    userList,
    values,
    handleSelectedEmployee,
    touched,
    errors,
    showModal,
    setShowModal,
    generatedUsername,
    generatedPassword,
  } = useCreateNewViewController();

  const text = {
    resetPassword: i18n.t('home.createNew.resetPassword'),
    createNewCredentials: i18n.t('home.createNew.createNewCredentials'),
    storeName: i18n.t('home.createNew.storeName'),
    storeLocationCode: i18n.t('home.createNew.storeLocationCode'),
    username: i18n.t('home.createNew.username'),
    assignAOM: i18n.t('home.createNew.assignAOM'),
    generatePassword: i18n.t('home.createNew.generatePassword'),
    submitBtn: i18n.t('home.createNew.submitBtn'),
    assignedAOM: i18n.t('home.createNew.assignedAOM'),
    backBtn: i18n.t('home.createNew.backBtn'),
  }
  return (
    <>
      <div className="container-fluid mt-5">
        <div className="smb-4">
          <h6 className="back-btn" onClick={goBack}>{text.backBtn}</h6>
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold txt-primary">
              {!state?.created ? text.resetPassword : text.createNewCredentials}
            </h6>
          </div>
          <Card style={{ width: "100%", height: "500px" }}>
            <Form onSubmit={handleSubmit} className="mt-4 mb-4 px-4">
              <Row>
                <Col className="col-lg-6">
                  <h5>
                    {text.storeName}
                    <span className="fs-sm">{state?.storename ?? "-"}</span>{" "}
                  </h5>
                </Col>
                <Col className="col-lg-6">
                  <h5>
                    {text.storeLocationCode} <span>{state?.storecode ?? "-"}</span>{" "}
                  </h5>
                </Col>
              </Row>
              {state?.created ? null : (
                <Row className="mt-4 mb-4">
                  <Col className="col-lg-6">
                    <h5>
                      {text.username}
                      <span className="fs-sm">{state?.username ?? "-"}</span>{" "}
                    </h5>
                  </Col>
                  <Col className="col-lg-6">
                    <h5>
                      {text.assignedAOM}
                      <span className="fs-sm">
                        {userList.find((e) => e?.id === state?.aom_id)?.label ??
                          "-"}
                      </span>{" "}
                    </h5>
                  </Col>
                </Row>
              )}
              {state?.created ? (
                <>
                  <Row className="mt-5">
                    <Col className="col-lg-8">
                      <Row>
                        <Col className="col-lg-2">
                          <div className="mt-2">
                            <p>
                              {text.assignAOM} <span style={{ color: "red" }}>*</span>
                            </p>
                          </div>
                        </Col>
                        <Col className="col-lg-5">
                          <div>
                            <SelectDropdown
                              placeholder="Select"
                              data={userList}
                              value={values?.selectedEmployee}
                              onChange={handleSelectedEmployee}
                              errors={
                                touched?.selectedEmployee &&
                                errors?.selectedEmployee
                              }
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row className="mt-5 d-flex justify-content-center">
                    <PrimaryButton
                      type="submit"
                      text={text.generatePassword}
                      className="width-auto save-btn mt-5"
                    />
                  </Row>
                </>
              )}

              <div className="d-flex">
                {!state?.created ? null : (
                  <>
                    <PrimaryButton
                      type="submit"
                      text={text.submitBtn}
                      className="width-auto save-btn "
                      disabled={values?.selectedEmployee === "" ? true : false}
                    />
                  </>
                )}
              </div>
              {showModal ? (
                <GenerateModal
                  isCreated={state?.created}
                  setShowModal={setShowModal}
                  showModal={showModal}
                  username={generatedUsername}
                  password={generatedPassword}
                  checkButton={values?.selectedEmployee === "" ? true : false}
                  handleSubmit={handleSubmit}
                />
              ) : null}
            </Form>
          </Card>
        </div>
      </div>
    </>
  );
};

export default CreateNew;
